export const TERRA_ALWAYS_ALLOWED_DOMAIN_RULES = [
  {
    pattern: '*.terra.security',
    role: 'platform',
  },
  {
    pattern: '*.internal.terrasec.io',
    role: 'internal_services',
  },
  {
    pattern: '*.terrasec.io',
    role: 'attack_infrastructure',
  },
  {
    pattern: '*.oob.terrasec.io',
    role: 'out_of_band_callbacks',
  },
] as const;

export type TerraAlwaysAllowedDomainRole =
  (typeof TERRA_ALWAYS_ALLOWED_DOMAIN_RULES)[number]['role'];

export type TerraAlwaysAllowedDomainPattern =
  (typeof TERRA_ALWAYS_ALLOWED_DOMAIN_RULES)[number]['pattern'];

export const TERRA_ALWAYS_ALLOWED_DOMAINS =
  TERRA_ALWAYS_ALLOWED_DOMAIN_RULES.map(
    ({ pattern }) => pattern,
  ) as readonly TerraAlwaysAllowedDomainPattern[];
